import React from 'react'
import Timer from './Timer.js'
import Com from './Com.js'
import MagicData from './MagicData.js'
import Translations from './Translations.js'
import { avatarColorKeys } from './colorKeys.ts'

const BUZZER_NAMES = ['up', 'select', 'down']

let buzzerInputMagicDatas = []
let buzzerDisplayMagicDatas = []
let buzzerDisplayMagicDatas2 = []
let buzzerActiveMagicDatas = []
let buzzerAvatarMagicDatas = []
let countdownTimerConfMagicDatas = []
let countdownTimerPositionMagicDatas = []
for (let i = 0; i < 4; i++) {
	buzzerInputMagicDatas[i] = MagicData.newMagicData(null)
	buzzerDisplayMagicDatas[i] = MagicData.newMagicData(null)
	buzzerDisplayMagicDatas2[i] = []
	buzzerActiveMagicDatas[i] = MagicData.newMagicData(null)
	buzzerAvatarMagicDatas[i] = MagicData.newMagicData(null)
	countdownTimerConfMagicDatas[i] = []
	countdownTimerPositionMagicDatas[i] = []
	for (let j = 0; j < 3; j++) {
		buzzerDisplayMagicDatas2[i][j] = MagicData.newMagicData(null)
		countdownTimerConfMagicDatas[i][j] = MagicData.newMagicData(null)
		countdownTimerPositionMagicDatas[i][j] = MagicData.newMagicData(null)
		Timer.newTimer(countdownTimerConfMagicDatas[i][j], countdownTimerPositionMagicDatas[i][j])
	}
}
let localeMagicData = MagicData.newMagicData('fr')

for (let i = 0; i < 4; i++) {
	buzzerDisplayMagicDatas[i].addChangeCb(function(newValue) {
		if (!newValue || newValue.length < 3) return
		for (let j = 0; j < 3; j++) {
			buzzerDisplayMagicDatas2[i][j].setValue(newValue[j])
		}
	})
	for (let j = 0; j < 3; j++) {
		buzzerDisplayMagicDatas2[i][j].addChangeCb(function(newValue) {
			if (newValue && newValue.length > 1) countdownTimerConfMagicDatas[i][j].setValue([Date.now(), 0, newValue[1], 0.1])
		})
	}
}

let initialized = false
function init() {
	initialized = true
	for (let i = 0; i < 4; i++) {
		Com.connectMagicData(buzzerInputMagicDatas[i], '', 'players.'+i+'.inputStatus')
		Com.connectMagicData(buzzerDisplayMagicDatas[i], '', 'players.'+i+'.buzzers')
		Com.connectMagicData(buzzerActiveMagicDatas[i], '', 'players.'+i+'.active')
		Com.connectMagicData(buzzerAvatarMagicDatas[i], '', 'players.'+i+'.avatar')
	}
	Com.connectMagicData(localeMagicData, '', 'locale')
}

function Buzzers() {

	if (!initialized) init()

	const [team, setTeam] = React.useState(null)
	const [locale, setLocale] = React.useState(localeMagicData.getValue())
	localeMagicData.addChangeCb(setLocale)

	const [buzzerDisplay1, setBuzzerDisplay1] = React.useState(buzzerDisplayMagicDatas[0].getValue())
	const [buzzerDisplay2, setBuzzerDisplay2] = React.useState(buzzerDisplayMagicDatas[1].getValue())
	const [buzzerDisplay3, setBuzzerDisplay3] = React.useState(buzzerDisplayMagicDatas[2].getValue())
	const [buzzerDisplay4, setBuzzerDisplay4] = React.useState(buzzerDisplayMagicDatas[3].getValue())
	let buzzerDisplays = [buzzerDisplay1, buzzerDisplay2, buzzerDisplay3, buzzerDisplay4]
	let setBuzzerDisplays = [setBuzzerDisplay1, setBuzzerDisplay2, setBuzzerDisplay3, setBuzzerDisplay4]
	for (let i = 0; i < 4; i++) {
		buzzerDisplayMagicDatas[i].addChangeCb(setBuzzerDisplays[i])
	}

	const [buzzerInput1, setBuzzerInput1] = React.useState(buzzerInputMagicDatas[0].getValue())
	const [buzzerInput2, setBuzzerInput2] = React.useState(buzzerInputMagicDatas[1].getValue())
	const [buzzerInput3, setBuzzerInput3] = React.useState(buzzerInputMagicDatas[2].getValue())
	const [buzzerInput4, setBuzzerInput4] = React.useState(buzzerInputMagicDatas[3].getValue())
	let buzzerInputs = [buzzerInput1, buzzerInput2, buzzerInput3, buzzerInput4]
	let setBuzzerInputs = [setBuzzerInput1, setBuzzerInput2, setBuzzerInput3, setBuzzerInput4]
	for (let i = 0; i < 4; i++) {
		buzzerInputMagicDatas[i].addChangeCb(setBuzzerInputs[i])
	}

	const [buzzerActive1, setBuzzerActive1] = React.useState(buzzerActiveMagicDatas[0].getValue())
	const [buzzerActive2, setBuzzerActive2] = React.useState(buzzerActiveMagicDatas[1].getValue())
	const [buzzerActive3, setBuzzerActive3] = React.useState(buzzerActiveMagicDatas[2].getValue())
	const [buzzerActive4, setBuzzerActive4] = React.useState(buzzerActiveMagicDatas[3].getValue())
	let buzzerActives = [buzzerActive1, buzzerActive2, buzzerActive3, buzzerActive4]
	let setBuzzerActives = [setBuzzerActive1, setBuzzerActive2, setBuzzerActive3, setBuzzerActive4]
	let anyBuzzerActive = false
	for (let i = 0; i < 4; i++) {
		buzzerActiveMagicDatas[i].addChangeCb(setBuzzerActives[i])
		if (buzzerActives[i]) anyBuzzerActive = true
	}

	const [buzzerAvatar1, setBuzzerAvatar1] = React.useState(buzzerAvatarMagicDatas[0].getValue())
	const [buzzerAvatar2, setBuzzerAvatar2] = React.useState(buzzerAvatarMagicDatas[1].getValue())
	const [buzzerAvatar3, setBuzzerAvatar3] = React.useState(buzzerAvatarMagicDatas[2].getValue())
	const [buzzerAvatar4, setBuzzerAvatar4] = React.useState(buzzerAvatarMagicDatas[3].getValue())
	let buzzerAvatars = [buzzerAvatar1, buzzerAvatar2, buzzerAvatar3, buzzerAvatar4]
	let setBuzzerAvatars = [setBuzzerAvatar1, setBuzzerAvatar2, setBuzzerAvatar3, setBuzzerAvatar4]
	for (let i = 0; i < 4; i++) {
		buzzerAvatarMagicDatas[i].addChangeCb(setBuzzerAvatars[i])
	}
	let avatarColor = '#404040'
	if (team !== null && buzzerAvatars[team] !== null) avatarColor = avatarColorKeys[parseInt(buzzerAvatars[team].split('_')[0])-1]

	// Sinon ça va, toi ?
	const [countdownTimerConf11, setCountdownTimerConf11] = React.useState(countdownTimerConfMagicDatas[0][0].getValue())
	const [countdownTimerConf12, setCountdownTimerConf12] = React.useState(countdownTimerConfMagicDatas[0][1].getValue())
	const [countdownTimerConf13, setCountdownTimerConf13] = React.useState(countdownTimerConfMagicDatas[0][2].getValue())
	const [countdownTimerConf21, setCountdownTimerConf21] = React.useState(countdownTimerConfMagicDatas[1][0].getValue())
	const [countdownTimerConf22, setCountdownTimerConf22] = React.useState(countdownTimerConfMagicDatas[1][1].getValue())
	const [countdownTimerConf23, setCountdownTimerConf23] = React.useState(countdownTimerConfMagicDatas[1][2].getValue())
	const [countdownTimerConf31, setCountdownTimerConf31] = React.useState(countdownTimerConfMagicDatas[2][0].getValue())
	const [countdownTimerConf32, setCountdownTimerConf32] = React.useState(countdownTimerConfMagicDatas[2][1].getValue())
	const [countdownTimerConf33, setCountdownTimerConf33] = React.useState(countdownTimerConfMagicDatas[2][2].getValue())
	const [countdownTimerConf41, setCountdownTimerConf41] = React.useState(countdownTimerConfMagicDatas[3][0].getValue())
	const [countdownTimerConf42, setCountdownTimerConf42] = React.useState(countdownTimerConfMagicDatas[3][1].getValue())
	const [countdownTimerConf43, setCountdownTimerConf43] = React.useState(countdownTimerConfMagicDatas[3][2].getValue())
	const [countdownTimerPosition11, setCountdownTimerPosition11] = React.useState(countdownTimerPositionMagicDatas[0][0].getValue())
	const [countdownTimerPosition12, setCountdownTimerPosition12] = React.useState(countdownTimerPositionMagicDatas[0][1].getValue())
	const [countdownTimerPosition13, setCountdownTimerPosition13] = React.useState(countdownTimerPositionMagicDatas[0][2].getValue())
	const [countdownTimerPosition21, setCountdownTimerPosition21] = React.useState(countdownTimerPositionMagicDatas[1][0].getValue())
	const [countdownTimerPosition22, setCountdownTimerPosition22] = React.useState(countdownTimerPositionMagicDatas[1][1].getValue())
	const [countdownTimerPosition23, setCountdownTimerPosition23] = React.useState(countdownTimerPositionMagicDatas[1][2].getValue())
	const [countdownTimerPosition31, setCountdownTimerPosition31] = React.useState(countdownTimerPositionMagicDatas[2][0].getValue())
	const [countdownTimerPosition32, setCountdownTimerPosition32] = React.useState(countdownTimerPositionMagicDatas[2][1].getValue())
	const [countdownTimerPosition33, setCountdownTimerPosition33] = React.useState(countdownTimerPositionMagicDatas[2][2].getValue())
	const [countdownTimerPosition41, setCountdownTimerPosition41] = React.useState(countdownTimerPositionMagicDatas[3][0].getValue())
	const [countdownTimerPosition42, setCountdownTimerPosition42] = React.useState(countdownTimerPositionMagicDatas[3][1].getValue())
	const [countdownTimerPosition43, setCountdownTimerPosition43] = React.useState(countdownTimerPositionMagicDatas[3][2].getValue())
	let countdownTimerConfs = [
		[countdownTimerConf11, countdownTimerConf12, countdownTimerConf13],
		[countdownTimerConf21, countdownTimerConf22, countdownTimerConf23],
		[countdownTimerConf31, countdownTimerConf32, countdownTimerConf33],
		[countdownTimerConf41, countdownTimerConf42, countdownTimerConf43]
	]
	let setCountdownTimerConfs = [
		[setCountdownTimerConf11, setCountdownTimerConf12, setCountdownTimerConf13],
		[setCountdownTimerConf21, setCountdownTimerConf22, setCountdownTimerConf23],
		[setCountdownTimerConf31, setCountdownTimerConf32, setCountdownTimerConf33],
		[setCountdownTimerConf41, setCountdownTimerConf42, setCountdownTimerConf43]
	]
	let countdownTimerPositions = [
		[countdownTimerPosition11, countdownTimerPosition12, countdownTimerPosition13],
		[countdownTimerPosition21, countdownTimerPosition22, countdownTimerPosition23],
		[countdownTimerPosition31, countdownTimerPosition32, countdownTimerPosition33],
		[countdownTimerPosition41, countdownTimerPosition42, countdownTimerPosition43]
	]
	let setCountdownTimerPositions = [
		[setCountdownTimerPosition11, setCountdownTimerPosition12, setCountdownTimerPosition13],
		[setCountdownTimerPosition21, setCountdownTimerPosition22, setCountdownTimerPosition23],
		[setCountdownTimerPosition31, setCountdownTimerPosition32, setCountdownTimerPosition33],
		[setCountdownTimerPosition41, setCountdownTimerPosition42, setCountdownTimerPosition43]
	]
	for (let i = 0; i < 4; i++) {
		for (let j = 0; j < 3; j++) {
			countdownTimerConfMagicDatas[i][j].addChangeCb(setCountdownTimerConfs[i][j])
			countdownTimerPositionMagicDatas[i][j].addChangeCb(setCountdownTimerPositions[i][j])
		}
	}

	// fonction translations
	function _(aText) {
		if (!Translations[locale]) return aText
		if (!Translations[locale][aText]) return aText
		return Translations[locale][aText]
	}

	return (
		<div style={{width: '1080px', height: '1920px', background: 'black', color: 'white', fontFamily: 'Adobe Caslon Pro Regular', fontSize: '50px', textAlign: 'center'}}>
			<img src='images/back1.png' style={{position: 'absolute', left: '0px', top: '0px', zIndex: '999', pointerEvents: 'none', width: '1080px', height: '1920px', objectFit: 'fill', opacity: '0.4', mixBlendMode: 'screen'}} />
			<div style={{padding: '70px 70px 0px 70px'}}>
				{team === null &&
					<div>
						<div style={{textAlign: 'left', paddingBottom: '100px'}}>{anyBuzzerActive?"Choisissez bien votre équipe ! 😈":"Aucune équipe pour l'instant ! 😮"}</div>
						<div style={{width: '940px', margin: 'auto'}}>
							{[0, 1, 2, 3].map(function(i) {
								avatarColor = '#404040'
								if (buzzerAvatars[i] !== null) avatarColor = avatarColorKeys[parseInt(buzzerAvatars[i].split('_')[0])-1]
								if (buzzerActives[i]) return (<div
									key={i}
									style={{float: 'left', width: '235px', height: '400px'}}
									onClick={function() {
										setTeam(i)
									}}
								>
									<div style={{paddingBottom: '50px'}}>Équipe {i+1}</div>
									<img src="images/buzzers.png" style={{width: '100px', border: '7px solid '+avatarColor}}/>
								</div>)
								else return (<div
									key={i}
									style={{float: 'left', width: '235px', height: '400px'}}
								></div>)
							})}
							<div style={{clear: 'both'}}></div>
						</div>
					</div>
				}
				{team !== null &&
					<div>
						<img
							src='images/icon_back.png'
							style={{float: 'left', width: '64px'}}
							onClick={function() {
								setTeam(null)
							}}
						/>
						{!buzzerAvatars[team] && <div style={{position: 'absolute', left: '0px', top: '150px', width: '1080px', height: '1080px', fontSize: '100px', pointerEvents: 'none'}}>Équipe {team+1}</div>}
						{buzzerAvatars[team] && <div style={{position: 'absolute', left: '0px', top: '-80px', width: '1080px', height: '1080px', backgroundImage: 'url(avatars/'+buzzerAvatars[team].replace('_', '.')+')', backgroundSize: 'cover', pointerEvents: 'none'}} />}
						<div style={{float: 'left', width: '64px'}}></div>
						<div style={{clear: 'both', paddingBottom: '250px'}}></div>
						<div style={{background: 'black', width: '500px', height: '1400px', margin: 'auto', border: '30px solid '+avatarColor}}>
							{[0, 1, 2].map(function(i) {
								if (!buzzerDisplays[team]) return
								let progress = 0
								if (buzzerDisplays[team] && buzzerDisplays[team][i] && buzzerDisplays[team][i].length > 1) progress = countdownTimerPositions[team][i]/countdownTimerConfs[team][i][2]
								let color = buzzerDisplays[team] && buzzerDisplays[team][i] && buzzerDisplays[team][i][0] ? buzzerDisplays[team][i][0] : 'black'
								let globalColor = 'black'
								let dotsColor = 'black'
								if (color !== 'black' && color !== '#000' && color !== '#000000') {
									let globalColorBrightness = progress == 1 ? 0 : Math.max(Math.min(1-progress, 0.9), 0.2)
									globalColor = 'color-mix(in srgb, '+color+' '+(globalColorBrightness*100)+'%, black)'
									dotsColor = 'color-mix(in srgb, '+color+' 85%, white)'
								}
								let input = buzzerInputs[team]
								if (!input) input = []
								let position = input.indexOf(BUZZER_NAMES[i])
								let on = position > -1
								let brightness = on?'175%':'100%'
								return (<div
									key={i}
									style={{background: 'url(images/buzzer.png)', width: '400px', height: '400px', margin: '50px', filter: 'brightness('+brightness+')', touchAction: 'none'}}
									onPointerDown={function() {
										let input = buzzerInputs[team]
										if (!input) input = []
										let position = input.indexOf(BUZZER_NAMES[i])
										let on = position > -1
										if (on) return
										input.push(BUZZER_NAMES[i])
										Com.setVariable('', 'players.'+team+'.inputStatus', input)
										if ('vibrate' in navigator) navigator.vibrate(100)
									}}
									onPointerUp={function() {
										let input = buzzerInputs[team]
										if (!input) input = []
										let position = input.indexOf(BUZZER_NAMES[i])
										let on = position > -1
										if (!on) return
										input.splice(position, 1)
										Com.setVariable('', 'players.'+team+'.inputStatus', input)
									}}
								>
									<div style={{background: globalColor, maskImage: 'url(images/buzzer2.png)', width: '400px', height: '400px', position: 'relative'}}>
										{[0, 30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330].map(function(j) {
											if ((j+30)/360 <= progress) return null
											let x = 125*Math.cos((j-60)*Math.PI/180)+200-50/2
											let y = 125*Math.sin((j-60)*Math.PI/180)+200-50/2
											return (<div
												key={i+'_'+j}
												style={{background: dotsColor, width: '50px', height: '50px', position: 'absolute', left: x+'px', top: y+'px', borderRadius: '50%'}}
											></div>)
										})}
									</div>
								</div>)
							})}
						</div>
					</div>
				}
			</div>
		</div>
	)
}

export default Buzzers
